import type { FolderCountDisplayMode } from '../store/schema/MailFolderNodeViewState';
import { getFolderViewStateFromIdNoFallback } from './getFolderViewStateFromId';

export const getFolderCountDisplayMode = (folderId: string): FolderCountDisplayMode | undefined => {
    return getFolderViewStateFromIdNoFallback(folderId)?.countDisplayMode;
};
